import { resetWebSockets } from './globals';
import { resetSubscribers } from './manage-subscribers';
export function assertIsWebSocket(webSocketInstance) {
    if (!('send' in webSocketInstance)) {
        throw new Error('');
    }
}
export function resetGlobalState(url) {
    resetSubscribers(url);
    resetWebSockets(url);
}
